// extracted by mini-css-extract-plugin
export default {"component":"DropdownMenuFooter_component__6Poy9","dark":"DropdownMenuFooter_dark__supBw"};